import { useCallback } from 'react'

type LinkTarget = '_self' | '_blank' | '_parent' | '_top'

interface UseOpenLinkReturn {
  openLink: (url: string, target?: LinkTarget) => boolean
  openLinkInNewTab: (url: string) => boolean
  openLinkInSameTab: (url: string) => boolean
}

const useOpenLink = (): UseOpenLinkReturn => {
  const openLink = useCallback((url: string, target: LinkTarget = '_blank'): boolean => {
    if (!url || typeof url !== 'string') {
      return false
    }

    let finalUrl = url;
    if(finalUrl.includes('/payment-form') && /[?&]data=[A-Za-z0-9\-_]+\.[A-Za-z0-9\-_]+\.[A-Za-z0-9\-_]+/.test(finalUrl)) {
      finalUrl = `${finalUrl}&returnUrl=${window.location.href}`
    }

    try {
      const link = document.createElement('a')
      link.href = finalUrl
      link.target = target
      
      if (target === '_blank') {
        link.rel = 'noopener noreferrer nofollow'
      } else {
        link.rel = 'noopener noreferrer'
      }
      
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      
      return true
    } catch (error) {
      return false
    }
  }, [])

  const openLinkInNewTab = useCallback((url: string): boolean => {
    return openLink(url, '_blank')
  }, [openLink])

  const openLinkInSameTab = useCallback((url: string): boolean => {
    return openLink(url, '_self')
  }, [openLink])

  return {
    openLink,
    openLinkInNewTab,
    openLinkInSameTab
  }
}

export default useOpenLink